const loadAlert = async (component) => {
    const response = await fetch(`/entrypoints/ajax/alerts/${component}`);

    const html = await response.text();

    return html;
};

const createAlertWrapper = (html) => {
    const wrapper = document.createElement('div');
    // wrapper.id = 'livewire-alert-wrapper';
    wrapper.className = 'js-alert-wrapper fade-in custom-alert';
    wrapper.innerHTML = html;
    return wrapper;
};

const removeAlertWrapper = (wrapper) => {
    wrapper.classList.replace('fade-in', 'fade-out');
    wrapper.addEventListener('animationend', () => {
        wrapper.remove();
    });
};

const ALERT_DURATION_TIME = 3000;

export const livewireAlert = () => {
    window.Livewire.on('show-alert', async ({ component, selector }) => {
        console.log(component, selector);
        // console.log(data);
        const targetElement = document.querySelector(selector);
        if (!targetElement) {
            return;
        }
        const html = await loadAlert(component);
        const alertWrapper = createAlertWrapper(html);
        targetElement.appendChild(alertWrapper);
        setTimeout(() => {
            removeAlertWrapper(alertWrapper);
        }, ALERT_DURATION_TIME);
    });
};
